export const planetChartData = {
  type: 'bar',
  data: {
    labels: ['Enero', 'Febrero', 'Marzo'],
    datasets: [

      { // one line graph
        label: "PTI's Diagnoticados",
        data: [15, 24, 21],
        backgroundColor: [
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      },
      { // one line graph
        label: '% error de diagnostico',
        data: [15, 24, 21],
        backgroundColor: [
          'rgba(54,73,93,.5)', // Blue
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          min: 0,
          beginAtZero: true,
          stacked: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }],
      xAxes: [{
        stacked: true
      }]
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var sumatotal = 0;
          data.datasets.forEach(function (value) {
            sumatotal = value.data[tooltipItem.index] + sumatotal;
          });
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var currentValue = dataset.data[tooltipItem.index];
          var porcentaje = (100 / sumatotal) * data.datasets[1].data[tooltipItem.index];
          return data.datasets[tooltipItem.datasetIndex].label + ": " + currentValue + "   Porcentaje de errores contra productividad: " + porcentaje.toFixed(2) + "%";
        }
      }
    }
  }
}

export default planetChartData;